import {get, patch, post} from "./request";

export const InterventionApi = {};
InterventionApi.getAll = async ({size, order, filter, search}) => {
  try {
    const {data} = await post(
      `/intervention/all`,
      {filter, order, search},
      {size}
    );
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

InterventionApi.getOne = async ({id, ...props}) => {
  try {
    const {data} = await get(`/intervention/one/${id}`, props);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

InterventionApi.update = async ({id, body}) => {
  try {
    const {data} = await patch(`/intervention/update/${id}`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

InterventionApi.CreateNextIntervention = async ({body}) => {
  try {
    const {data} = await post(`/intervention/createNextIntervention`, body);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

InterventionApi.payIntervention = async ({interventionId}) => {
  try {
    const {data} = await post(`/intervention/payAdditionalPrice`, {
      interventionId,
    });

    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
